import { React, useState, useEffect } from '../utils/thirdpartyComponents';
import CarwashLogo from '../assets/images/CarWash-Logo.svg';
import { getFromLocalStorage } from 'src/utils/helper';

interface LoadingProps {}

function LoadingMessage() {

  const settings = getFromLocalStorage('CARWASH_COMPANY_SETTINGS_DATA') || {};
  const IsCustom = settings?.IsCustom ? settings.IsCustom : 0;
  //if default design set defalut logo
  const Logourl_from_appsettings = IsCustom === 0 ? "" : getFromLocalStorage('LOGO_URL_SETTINGS_DATA');

  let displayMode = 'browser';
  const mqStandAlone = '(display-mode: standalone)';
  if ((window.navigator as any).standalone || window.matchMedia(mqStandAlone).matches) {
    displayMode = 'standalone';
  }
  if (displayMode === 'standalone') {
    return (
      <div className="splash-screen d-flex align-items-center justify-content-center">
        <div className="logo position-relative"><img src={Logourl_from_appsettings ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH}${Logourl_from_appsettings}` : CarwashLogo } alt="carwash app"  width={220} /></div>
      </div>
    );
    
  }
  else
  {
    return ('');
  }
}

function withSplashScreen<P extends LoadingProps>(WrappedComponent: React.ComponentType<P>) {
  return function SplashScreenComponent(props: P) {
    const [loading, setLoading] = useState(true);
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
      const checkStandalone = () => {
        const isIosStandalone = (window.navigator as any).standalone;
        const isOtherStandalone = window.matchMedia('(display-mode: standalone)').matches;
        return isIosStandalone || isOtherStandalone;
      };

      setIsStandalone(checkStandalone());

      const loadSession = async () => {
        try {
          setTimeout(() => {
            setLoading(false);
          }, 1500);
        } catch (err) {
          console.log(err);
          setLoading(false);
        }
      };

      if (checkStandalone()) {
        loadSession();
      } else {
        setLoading(false);
      }
    }, []);

    if (loading) return <LoadingMessage />;

    return <WrappedComponent {...props} />;
  };
}

export default withSplashScreen;